import React from "react";

const Cross = () => {
  return (
        <svg width="24" height="24" role="img" aria-label="Cross" fill="none" viewBox="0 0 24 24">
            <path fill="#8C9AAD" fillRule="evenodd" d="M5.205 5.205c.439-.44 1.151-.44 1.59 0L12 10.409l5.204-5.205a1.125 1.125 0 0 1 1.591 1.591L13.591 12l5.205 5.204a1.125 1.125 0 0 1-1.591 1.591L12 13.591l-5.205 5.205a1.125 1.125 0 0 1-1.59-1.591L10.409 12 5.204 6.795a1.125 1.125 0 0 1 0-1.59Z" clipRule="evenodd"/>
        </svg>
  );
};

export default Cross;
